import { render, staticRenderFns } from "./TicketComponent.vue?vue&type=template&id=412c6832&"
import script from "./TicketComponent.vue?vue&type=script&lang=ts&"
export * from "./TicketComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TicketComponent.vue?vue&type=style&index=0&id=412c6832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports